import React, { Fragment } from "react"
let alignV = data => {
    let h = [
        "SAMPLE",
        "CAD",
        "FABRIC",
        "TRIM",
        "PATTERN",
        "CUTTING",
        "SEWING",
        "GARMENT TECH",
        "EMBELLISHMENT",
        "EMBROIDERY",
        "WASH",
        // "QC",
        'GRADING',
        "MARKER",
        "COSTING",
        "SIGNOFF",
        "DISPATCH"
    ]
    if (h.includes(data)) {
        return true
    } else {
        return false
    }
}
let setTitle = (data, type) => {
    if (typeof data === "object") {
        if (type === "content") {
            if (typeof data.status === 'object') {
                return data.status.status
            } else {
                return data.status
            }
        } else {
            return data.assignedTo
        }
    } else {
        return data
    }
}

let changeBg = data => {
    let isBlue = false, status
    if (typeof data.status === "object") {
        status = data.status.status
        isBlue = true
    } else {
        status = data.status
    }
    switch (status) {
        case "P":
            return `${!isBlue && 'bg-danger' || 'bg-primary'} p-2 text-white font-weight-bold borderDark align-middle`
        case "CA":
            return `${!isBlue && 'bg-dark' || 'bg-primary'} py-2 px-1 text-white font-weight-bold borderDark align-middle`
        case "C":
            return `${!isBlue && 'bg-success' || 'bg-primary'} p-2 text-white font-weight-bold borderDark align-middle`
        case "IN":
            return `${!isBlue && 'bg-warning' || 'bg-primary'} py-2 px-1 text-white font-weight-bold borderDark align-middle`
        case "X":
            return `${!isBlue && 'bg-yellow' || 'bg-primary'} p-2 text-dark font-weight-bold borderDark align-middle`
        case "":
            return `bg-primary p-2 text-white font-weight-bold borderDark align-middle`
        default:
            return "wordwrap py-1"
    }
}

let showHead = (data, headers) => {
    if (headers.length) {
        headers.map(x => x.label)
        if (headers.includes(data)) {
            return "d-none"
        }
    }

}

function SampleReportByProcessesList(props) {
    console.log(props, "props");

    let { header, showHeaders } = props;
    return (
        <Fragment>
            <div className="text-center">
                <h6>Samples Report by Processes</h6>
                <p>
                    P - PENDING &nbsp;&nbsp; CA - Cancelled &nbsp;&nbsp; C -
                    Completed &nbsp;&nbsp; IN - InProcess &nbsp;&nbsp; X -
                    NotAllocated
                </p>
            </div>
            {Object.keys(header).length > 0 && header.h1 && (
                <Fragment>
                    <tr>
                        {header &&
                            header.h2 &&
                            header.h2.length > 0 &&
                            header.h2.map((x, i) => {
                                return (
                                    <td
                                        width={
                                            !alignV(x) && x === "STYLE NAME" && "19%"
                                        }
                                        className={`report-header ${alignV(x) &&
                                            "m-0 p-0"} ${showHead(x, showHeaders)}`}
                                    >
                                        {i === 0 && header.h1}
                                        <span
                                            className={`${alignV(x) ? "rotate90 p-0 m-0" : x === "DATE" ? "Date" : "wordwrap"
                                                }`}
                                        >
                                            {x === "CAD" && "3D" || x}
                                        </span>
                                    </td>
                                )
                            })}
                    </tr>
                </Fragment>
            )}
            {
                props.list &&
                props.list.length > 0 &&
                props.list.map((x, i) => {
                    return (
                        <Fragment>
                            {/* <tr>
                    <td colSpan="23" className="text-left w-100">
                      <span style={{ borderTop: "1px solid var(--primary-color)", fontSize: ".8rem" }} className="w-100 d-block">
                        Date {x.date}
                      </span>
                    </td>
                  </tr> */}
                            <tr>
                                <td colSpan="23" className="text-left h6 w-100 p-0">
                                    <span
                                        style={{
                                            borderBottom: "1px solid var(--primary-color)"
                                        }}
                                        className="w-100 d-block"
                                    >
                                        {x.name}
                                    </span>
                                </td>
                            </tr>
                            {x.data.map(dat => {
                                return (
                                    <tr>
                                        {Object.keys(dat).map((k, i) => {
                                            if (k === "IMAGE" && dat[k] !== "") {
                                                if (props.state.image === "true") {
                                                    return (
                                                        <td>
                                                            <img
                                                                onClick={() => dat[k] && props.modalData(dat[k])}
                                                                src={`${dat[k]}`}
                                                                style={{
                                                                    width: " 50px",
                                                                    height: "50px"
                                                                }}
                                                            />
                                                        </td>
                                                    )
                                                }
                                            } else if (k === "SR No") {
                                                return (
                                                    <td>
                                                        {" "}
                                                        <span
                                                            className="under-line cursor-hover"
                                                            onClick={() => {
                                                                if (
                                                                    !props.sampleRights.sampleRequest.web.edit &&
                                                                    !props.sampleRights.sampleRequest.web.view
                                                                ) {
                                                                    props.getalertMessage(
                                                                        "info",
                                                                        "no access"
                                                                    )
                                                                } else {
                                                                    let action = (props['sampleRights'].sampleRequest.web.edit && "edit") || (props['sampleRights'].sampleRequest.web.view && "view");
                                                                    let search = "?" + new URLSearchParams({
                                                                        action: action,
                                                                        _id: dat[k]._id
                                                                    }).toString()
                                                                    window.open(`/Sample${search}`, "_blank")
                                                                    // props.history.push("/Sample", {
                                                                    //     action:
                                                                    //         (props.rights.sampleRights.web.edit &&
                                                                    //             "edit") ||
                                                                    //         (props.rights.sampleRights.web.view &&
                                                                    //             "view"),
                                                                    //     _id: dat[k]._id,
                                                                    //     report: { ...props.state },
                                                                    //     route: "Report"
                                                                    // })
                                                                }
                                                            }}
                                                        >
                                                            {dat[k].number}
                                                        </span>
                                                    </td>
                                                )
                                            } else if (
                                                k === "STYLE NO" ||
                                                k === "STYLE NAME"
                                            ) {
                                                if (k === "STYLE NO") {
                                                    return (
                                                        <td>
                                                            <span
                                                                className="under-line cursor-hover"
                                                                onClick={() => {
                                                                    if (
                                                                        !props.styleRights.web.edit &&
                                                                        !props.styleRights.web.view
                                                                    ) {
                                                                        props.getalertMessage(
                                                                            "info",
                                                                            "no access"
                                                                        )
                                                                    } else {
                                                                        let action = (props.styleRights.web.edit && "edit") || (props.styleRights.web.view && "view");
                                                                        let search = "?" + new URLSearchParams({
                                                                            action: action,
                                                                            _id: dat[k]._id
                                                                        }).toString()
                                                                        window.open(`/StylePage${search}#seleted${dat[k].code.split("-").join("")}`, "_blank")
                                                                    }
                                                                }}
                                                            >
                                                                {dat[k].code}
                                                            </span>
                                                        </td>
                                                    )
                                                }
                                                 else {
                                                    return (
                                                        <td className="text-left">
                                                            <span
                                                                className="under-line cursor-hover"
                                                                onClick={() => {
                                                                    if (
                                                                        !props.styleRights.web.edit &&
                                                                        !props.styleRights.web.view
                                                                    ) {
                                                                        props.getalertMessage(
                                                                            "info",
                                                                            "no access"
                                                                        )
                                                                    } else {
                                                                        let action = (props.styleRights.web.edit && "edit") || (props.styleRights.web.view && "view");
                                                                        let search = "?" + new URLSearchParams({
                                                                            action: action,
                                                                            _id: dat["STYLE NO"]._id
                                                                        }).toString()
                                                                        window.open(`/StylePage${search}#seleted${dat["STYLE NO"].code.split("-").join("")}`, "_blank")
                                                                    }
                                                                }}
                                                            >
                                                                {dat[k]}
                                                            </span>
                                                        </td>
                                                    )
                                                }
                                            }else if (k === "SAMPLE TYPE") {
                                                // Apply left alignment when SAMPLE TYPE
                                                return (
                                                    <td
                                                        className="text-left" // Add left alignment class here
                                                        style={{ padding: ".1rem" }} // Optionally, add some padding for visual consistency
                                                        title={setTitle(dat[k], "title")}
                                                    >
                                                        <span className={`${changeBg(dat[k])}`}>
                                                            {setTitle(dat[k], "content")}
                                                        </span>
                                                    </td>
                                                );
                                            } else {
                                                return (
                                                    <td
                                                        className="m-0"
                                                        style={{ padding: ".1rem", cursor: alignV(k) && 'pointer' || '' }}
                                                        title={setTitle(dat[k], "title")}
                                                    >
                                                        <span
                                                            className={`${changeBg(dat[k])}`}
                                                            onClick={() => {
                                                                if (alignV(k) &&
                                                                    (!props.sampleRights[k.toLowerCase() === "garment tech" && "garmentTech" || k.toLowerCase()].web.edit &&
                                                                        !props.sampleRights[k.toLowerCase() === "garment tech" && "garmentTech" || k.toLowerCase()].web.view)
                                                                ) {
                                                                    props.getalertMessage(
                                                                        "info",
                                                                        "no access"
                                                                    )
                                                                } else if (alignV(k)) {
                                                                    let action = (props.sampleRights[k.toLowerCase() === "garment tech" && "garmentTech" || k.toLowerCase()].web.edit && "edit") || (props.sampleRights[k.toLowerCase() === "garment tech" && "garmentTech" || k.toLowerCase()].web.view && "view");
                                                                    let search = "?" + new URLSearchParams({
                                                                        action: action,
                                                                        _id: dat['SR No']._id,
                                                                    }).toString()
                                                                    window.open(`/Sample${search}#${k === "GRADING" && 'QC' || k === "GARMENT TECH" && 'garmentTechnologist' || k}`, "_blank")
                                                                }
                                                            }}
                                                        >
                                                            {setTitle(dat[k], "content")}
                                                        </span>
                                                    </td>
                                                )
                                            }
                                        })}
                                    </tr>
                                )
                            })}
                        </Fragment>
                    )
                })
            }
        </Fragment>
    )
}
export default SampleReportByProcessesList;


// WEBPACK FOOTER //
// ./src/components/Report/reports/sampleReportByProcessesList.js